// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2XAj3","shadow":"Header_shadow__14CrY","spacer":"Header_spacer__kPb1N","action":"Header_action__3vwQy"};